import React from 'react';
import { Link } from 'react-router-dom';

import FsButton from '~/components/core/FsWrappers/FsButton/FsButton';
import type { ClaimSearchResult } from '~/components/SearchBar/ClaimSearchTypes';

interface GoToClaimButtonProps {
  claim: ClaimSearchResult;
  onSelect?: (claim: ClaimSearchResult) => void;
}

const GoToClaimButton: React.FC<GoToClaimButtonProps> = ({ claim, onSelect }) => {
  return (
    <FsButton
      color="primary"
      component={Link}
      to={`/claims/${claim.id}`}
      onClick={onSelect ? () => onSelect(claim) : undefined}
    >
      <span className="whitespace-nowrap">Go to claim</span>
    </FsButton>
  );
};

export default GoToClaimButton;
